const auditRows = [
  {
    when: 'Mar 21, 2026 08:00',
    who: 'admin@umb.com',
    what: 'Routing: BR-SPV-I default pledge approver updated',
  },
  {
    when: 'Mar 19, 2026 15:22',
    who: 'risk@umb.com',
    what: 'Entitlement: maker-checker enforced on release queue',
  },
  {
    when: 'Mar 18, 2026 10:10',
    who: 'system',
    what: 'Notification: SLA digest enabled for custody ops',
  },
];

export function CustodianSettingsPage() {
  return (
    <div className="page-stack">
      <section className="card-shell p-4 sm:p-5">
        <h2 className="text-sm font-semibold text-umb-neutral-dark">
          Internal routing & entitlements
        </h2>
        <p className="mt-1 text-xs text-evault-muted">
          Internal routing, user entitlements, and notification preferences
          (mock).
        </p>
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          <label className="flex flex-col gap-1 text-xs">
            <span className="font-medium text-umb-neutral-dark">
              Default pledge approver pool
            </span>
            <select className="rounded-lg border border-evault-border bg-white px-3 py-2 text-sm">
              <option>Custody ops — team A</option>
              <option>Custody ops — team B</option>
            </select>
          </label>
          <label className="flex flex-col gap-1 text-xs">
            <span className="font-medium text-umb-neutral-dark">
              Exception escalation
            </span>
            <select className="rounded-lg border border-evault-border bg-white px-3 py-2 text-sm">
              <option>Legal + provider liaison</option>
              <option>Ops lead only</option>
            </select>
          </label>
        </div>
      </section>

      <div className="grid gap-3 lg:grid-cols-3">
        <section className="card-shell p-4 sm:p-5 lg:col-span-2">
          <h2 className="text-sm font-semibold text-umb-neutral-dark">
            Audit trail
          </h2>
          <p className="mt-1 text-xs text-evault-muted">
            Recent custody workspace configuration changes.
          </p>
          <ul className="mt-4 divide-y divide-evault-border">
            {auditRows.map((row) => (
              <li key={row.when + row.what} className="py-3 first:pt-0">
                <p className="text-xs font-medium text-umb-neutral-dark">
                  {row.what}
                </p>
                <p className="mt-1 text-[11px] text-evault-muted">
                  {row.when} · {row.who}
                </p>
              </li>
            ))}
          </ul>
        </section>
        <section className="card-shell p-4 sm:p-5">
          <h2 className="text-sm font-semibold text-umb-neutral-dark">
            Notifications
          </h2>
          <ul className="mt-3 space-y-2 text-xs text-umb-neutral-dark/80">
            <li className="rounded-lg bg-evault-surface px-3 py-2 ring-1 ring-evault-border">
              Daily digest: queues exceeding SLA
            </li>
            <li className="rounded-lg bg-evault-surface px-3 py-2 ring-1 ring-evault-border">
              Instant: delivery failure on custody receipt
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}
